import React from 'react';
import PropTypes from 'prop-types';
import ParentTableItem from './ParentTableItem';

const ParentTableItems = ({ tableItems }) => {
    // Verifica si tableItems es un array
  if (!Array.isArray(tableItems)) {
    console.error('tableItems debe ser un array');
    return null; // O cualquier otro manejo de error que desees
  }
  const allTableItems = tableItems.map(tableItem => (
    <ParentTableItem key={tableItem.id} tableItem={tableItem} />
  ));

  return <tbody>{allTableItems}</tbody>;
};

ParentTableItems.propTypes = {
  tableItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  tableHeads: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleEditFormOpen: PropTypes.func,
};

ParentTableItems.defaultProps = {
  tableItems: [
    {
      codigoContrato: "CONTRATO01",
      esCabecera: true,
      codigoPartida: "PARTIDA01",
      codigoSubPartida: "SUBPARTIDA01",
      
      l_polinomios: [{
        id: 1,
        tipoPolinimioTitle: "Title",
        tipoPolinomioId:  1,
        partidaId: 7,
        subPartidaId:  9,
        ponderador: 5.5,
        fechaBase: Date.now(),
        periodicidadMeses: 5,
        primerMesReajuste: "",
        valorBase: 519546350.65380,
        mesesDesfase: 5
      }],
      l_SUBPARTIDA: []
    },
  ],
};

export default ParentTableItems;
